module.exports = __webpack_public_path__ + "static/media/chain.6af17587.svg";